/********************************************
 * 封装axios请求  依赖element-ui
 * 使用说明：
 * 1、import http from '../../../utils/http';
 * 2、Vue.prototype.http = http;
 * 3、使用：this.http.get(url,unShowLoading).then(res=>{...}).catch(err=>{...})
 ********************************************/
import axios from 'axios';
import qs from 'qs';
// import app from '../../main.js';
import {
  Message,
  Loading
} from 'element-ui';
// axios的基础设置
// axios.defaults.withCredentials = true;
// if (window.urlConfig.url) {
//   axios.defaults.baseURL = window.urlConfig.url;
// }
// axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';


const http = {};
let loading = '';

/****** 创建axios实例
 * process.env.BASE_URL在config/dev.evn.js、prod.evn.js里面进行配置
 * ******/
const service = axios.create({
  // baseURL: process.env.BASE_URL, // api的base_url
  baseURL: window.urlConfig.url || process.env.BASE_URL || '', // api的base_url
  withCredentials: true, // 携带session
  // timeout: 8000 // 请求超时时间
});
// let cancel ,promiseArr = {};
/****** request拦截器==>对请求参数做处理 ******/
service.interceptors.request.use(
  config => {
    // console.log('load::::',Loading.service);

    // app.$vux.loading.show({
    //   text: '数据加载中……'
    // });
    // 判断是否存在token，如果存在的话，则每个http header都加上token
    // if (store.state.token) {
    //   config.headers.Authorization = `token ${store.state.token}`;
    // }
    // config.method === 'post'
    //   ? config.data = qs.stringify({...config.data})
    //   : config.params = {...config.params};
    config.method === 'post' ? config.data = {
      ...config.data
    } : config.params = {
      ...config.params
    };
    // config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    // config.headers['Content-Type'] = 'application/json;charset=UTF-8';
    // if (promiseArr[config.url]) {//发起请求时，取消掉当前正在进行的相同请求
    //   promiseArr[config.url]('操作取消')
    //   promiseArr[config.url] = cancel
    // }else{
    //   promiseArr[config.url] = cancel
    // }
    // console.log('request拦截器==>请求接收到的参数000::::', config);
    let url = config.url;
    // get参数编码
    if (config.method === 'get' && config.params) {
      url += '?';
      let keys = Object.keys(config.params);
      for (let key of keys) {
        url += `${key}=${encodeURIComponent(config.params[key])}&`
      }
      url = url.substring(0, url.length - 1);
      config.params = {}
    }
    config.url = url;

    // console.log('request拦截器==>请求接收到的参数::::', config);
    return config;
  },
  error => { //请求错误处理
    console.error('请求参数错误处理::', error);
    // app.$vux.toast.show({
    //   type: 'warn',
    //   text: error
    // });
    Promise.reject(error);
  }
);

/****** respone拦截器==>对响应做处理 ******/
service.interceptors.response.use(
  response => { //成功请求到数据
    // loading.close();
    // console.log(response.data, "respose 拦截")
    if (response.status === 200 && Number(response.data.code) === 0 || response.data.result == 0) {
      return response.data;
    } else {
      // 当接口检测到session或者未登录时，跳转到登陆页面
      if (response.data.code === '1') {
        Message({
          showClose: true,
          message: response.data.status,
          type: 'warning',
          duration: 5000
        });
        console.warn(`提示  code：${response.data.code}，信息：${response.data.status}`);
        // console.log('vue-router：',Vue,Vue.router,window.VUE,window.VUE.router,window.VUE.$router);
        window.VUE.$router.replace('/login');
        // return Promise.reject(response.data);
      } else {
        // console.log('引入的文件：：：',Message,Loading,Vue);
        Message({
          showClose: true,
          message: response.data.status,
          type: 'warning',
          duration: 5000
        });
        console.warn(`提示  code：${response.data.code}，信息：${response.data.status}`);
        // window.VUE.$router.replace('/login');
        return Promise.reject(response.data);

      }
    }
    // app.$vux.loading.hide();
    // 这里根据后端提供的数据进行对应的处理
    // if (response.data.result === 'TRUE') {
    //   return response.data;
    // } else {
    //   console.error('响应错误处理::',response.data.data.msg);
    //   // app.$vux.toast.show({ //常规错误处理
    //   //   type: 'warn',
    //   //   text: response.data.data.msg
    //   // });
    // }
  },
  error => { //响应错误处理
    // loading.close();
    let err = JSON.parse(JSON.stringify(error)),
      text = '网络异常，或接口错误，请重试';
    if (err && err.response && err.response.status === 404) {
      text = '404， 网络异常，或接口错误，请重试';
    }
    Message({
      showClose: true,
      message: `错误：${text}`,
      type: 'warning',
      duration: 5000
    });
    console.warn(`错误提示${err && err.response && err.response.status?' code：'+err.response.status +' ， ': ''}信息：${JSON.stringify(error)}`);
    // 如果错误则跳转到登录页
    // if (error.response) {
    //   switch (error.response.status) {
    //     case 401:
    //       // 返回 401 清除token信息并跳转到登录页面
    //       store.commit(types.LOGOUT);
    //       router.replace({
    //         path: 'login',
    //         query: {redirect: router.currentRoute.fullPath}
    //       })
    //   }
    // }
    return Promise.reject(error);
  }
);

http.get = function (url, unShowLoading) {
  if (unShowLoading === true) {
    return http.request(url, '', '', true);
  } else {
    return http.request(url);
  }
};
http.post = function (url, data, unShowLoading) {
  if (unShowLoading === true) {
    return http.request(url, data, 'post', true);
  } else {
    return http.request(url, data, 'post');

  }
};
http.put = function (url, data, unShowLoading) {
  if (unShowLoading === true) {
    return http.request(url, data, 'put', true);
  } else {
    return http.request(url, data, 'put');
  }
};
http.delete = function (url, unShowLoading) {
  if (unShowLoading === true) {
    return http.request(url, 'delete', true);
  } else {
    return http.request(url, 'delete');
  }
};
http.request = function (url, data, type, unShowLoading) {
  if (!url) {
    console.error('请填写请求地址，当前收到的参数为：', url, data, type);
    return;
  }
  let method = '',
    dat = data || '';
  if (data) {
    if (typeof (data) === 'object') {
      method = 'post';
    } else if (typeof (data) === 'string') {
      data = data.toLocaleLowerCase ? data.toLocaleLowerCase() : data.toLowerCase();
      if (data === 'get' || data === 'post' || data === 'put') {
        method = data;
        dat = '';
      }
    } else {
      method = 'post';
    }
  } else {
    method = 'get';
  }
  // if (unShowLoading === true) {
  //   loading = Loading.service({
  //     text: '.',
  //     lock: true,
  //     spinner: 'el-icon-loading',
  //     background: 'rgba(0, 0, 0, 0.01)'
  //   });
  //   loading.close();
  // } else {
  //   loading = Loading.service({
  //     text: '数据加载中……',
  //     lock: true,
  //     spinner: 'el-icon-loading',
  //     background: 'rgba(0, 0, 0, 0.3)'
  //   });
  // }
  return service({
    url: url,
    method: type || method,
    data: dat,
    headers: {
      // 'Content-Type':'application/x-www-form-urlencoded'
      // 'Content-Type':'application/json;charset=UTF-8'
      'Content-Type': 'application/json;'
    }
  });
};


export default http;